import React from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import styles from './FloatingButtons.module.css';

const FloatingButtons = () => {
  const whatsappNumber = '919099099901';
  const phoneNumber = '+919099099901';

  return (
    <div className={styles.floatingButtons}>
      <a
        href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in Bahariya Farm Bilona Ghee`}
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.floatingBtn} ${styles.whatsappBtn}`}
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
        <span className={styles.tooltip}>WhatsApp Us</span>
      </a>
      <a
        href={`tel:${phoneNumber}`}
        className={`${styles.floatingBtn} ${styles.phoneBtn}`}
        aria-label="Call"
      >
        <FaPhone />
        <span className={styles.tooltip}>Call Us</span>
      </a>
    </div>
  );
};

export default FloatingButtons;
